export default "__VITE_ASSET__CPqXjx5G__"